import {
	Box,
	Card,
	Text
} from "@chakra-ui/react";
import LocalSpinner from "components/LocalSpinner";
import { useQuery } from "react-query";
// import { Card } from "components/Card";
import { getWeaviateQuestion } from "api/ai/ai.service";
import questionService from "api/issb/question.service";
import { RightSidebarHeader } from "components/Layout/RightSidebarWidget";
import { H3 } from "components/text/headings";
import { QCardBody, QCardHeader } from "./IssbDataInput/components/QuestionCard";

/**
 *
 * @param {Object} props
 * @param {Citation} props.citation
 * @param {HTMLElement} props.domElement The <cite>[1]</cite> element, from which we extract the "[1]"
 * @param {ReportDoc} props.reportDoc
 */
export default function CitationSidePanel({ citation, domElement, questionId, label, title, reportDoc }) {
  let weaviateQuestionId = citation && citation["data-question_id"]; // HACK make a link to this
  let weaviateSourceId = citation && citation["data-source_id"];
  if ( ! label) label = domElement.textContent;  
  // load question data
  const { data: question, isLoading: isLoadingQuestion } = useQuery({
    queryKey: ["question", weaviateQuestionId || questionId],
    queryFn: async () => {
		if ( ! questionId) {
		const wq = await getWeaviateQuestion(weaviateQuestionId);
		console.log("wq => ", wq);
		questionId = wq.questionId;
		}
      return questionService.get(questionId);
    },
    enabled: !!(weaviateQuestionId || questionId),
  });
  if ( ! title) title = citation?.title || question?.title;

  console.log("question data => ", question);

  return (
    <Box>
      <RightSidebarHeader>Citation {label}</RightSidebarHeader>
      <H3 mt={4}>{title}</H3>
      {/* <QuestionCard question={question} showMultiPartAnswer={true} /> */}
      {isLoadingQuestion && <LocalSpinner />}
      {!isLoadingQuestion && !question && (
        <Card p={5}>
          <Text>Details unavailable</Text>
        </Card>
      )}
      {question && (
        <Card p={5}>
          <QCardHeader
            reference={question.issbReference}
            title={question.question}
            stage={question.stage}
            stageType={question.stageType}
            owner={question.owner}
            assignees={question.assignees}
            id={question.id}
          />
          <QCardBody q={question} showMultiPartAnswer={true} readOnly={true} />
        </Card>
      )}
    </Box>
  );
}
